import {
  GET_PRODUCT_TO_CONFIGURE_REQUEST,
  GET_PRODUCT_TO_CONFIGURE_SUCCESS,
  GET_PRODUCT_TO_CONFIGURE_FAILURE,
  CHANGE_VARIANT_REQUEST,
  CHANGE_VARIANT_SUCCESS,
  CHANGE_VARIANT_FAILURE,
  UPDATE_PRICE,
  INCREMENT_ITEM,
  DECREMENT_ITEM,
  INCREMENT_SUB_ITEM,
  DECREMENT_SUB_ITEM,
  EDIT_PRODUCT_CONFIGURATION,
  CANCEL_EDIT_PRODUCT_CONFIGURATION,
  CLEAR_PRODUCT_TO_CONFIGURE,
  VALIDATE_PRODUCT,
  VALIDATE_OPTION,
  EDIT_PREVIOUS_PRODUCT_CONFIGURATION_SUCCESS,
  EDIT_PREVIOUS_PRODUCT_CONFIGURATION_REQUEST,
  REMOVE_ITEM,
  REMOVE_SUB_ITEM,
  SET_DRAWER_MODAL_OPEN,
  ADD_ORDER_INSTRUCTION,
  INCREMENT_PRODUCT_QUANTITY,
  DECREMENT_PRODUCT_QUANTITY,
  GET_SPECIFIC_PRODUCT_WITH_OPTION,
  GET_SPECIFIC_PRODUCTS_WITH_OPTION,
} from "./productCustomizerTypes";
import api from "../../api";
import flattenProduct from "../../utils/flattenProduct";
import calculatePrice from "../../utils/calculatePrice";
import updateProductErrors from "./utils/updateProductErrors";
import updateOptionError from "./utils/updateOptionError";
import useDefaultItems from "./utils/useDefaultItems";
import { transformComboItemForProductCustomizer } from "../Combo/comboTransformers";
import perserveOnVariantChange from "./utils/perserveOnVariantChange";
import { PICKUP, DELIVERY, DROPOFF } from "../OrderSetting/orderSettingTypes";
import removeDefaultItems from "./utils/removeDefaultItems";
import { isItemUnavailable } from "../OrderHistory/utils/handleCompareProducts";
import { forEach } from "lodash";

export function getProduct(productId, businessId, variantId, product) {
  let defaultCustomization = "";
  if (product) {
    defaultCustomization = `&default_customization=${product.has_valid_configuration}`;
  }
  return api.get(
    `/products/${productId}?business_id=${businessId}&include=options,tags${
      variantId
        ? `&variant_id=${variantId}`
        : `&variant_id=${product?.prices[0]?.variant_id}`
    }${defaultCustomization}`
  );
}

export function getSpecificProduct(pastProduct) {
  return function(dispatch, getState) {
    const businessID = parseInt(localStorage.getItem("business_id"));
    const { product_id, variant_id } = pastProduct;
    return api
      .get(
        `/products/${product_id}?business_id=${businessID}&include=options&variant_id=${variant_id}&default_customization=true`
      )
      .then((res) => {
        dispatch({
          type: GET_SPECIFIC_PRODUCT_WITH_OPTION,
          selectedProduct: res.data.data,
        });
      });
  };
}
export function getSpecificProducts(productIds) {
  return function(dispatch, getState) {
    const businessID = parseInt(localStorage.getItem("business_id"));
    return Promise.all(
      productIds.map((id) =>
        api.get(
          `/products/${id}?business_id=${businessID}&include=options&default_customization=true`
        )
      )
    ).then((res) => {
      const productsWithOptions = productIds.map(
        (_, index) => res[index].data.data
      );
      dispatch({
        type: GET_SPECIFIC_PRODUCTS_WITH_OPTION,
        selectedProducts: productsWithOptions,
      });
    });
  };
}
export function updateShortageMessageInOrderAgainProducts(message) {
  return function(dispatch) {
    dispatch({
      type: "UPDATE_SHORTAGE_PRODUCTS_MESSAGE",
      globalProductsShortageMessages: message,
    });
  };
}

export function getProductToConfigure(
  product_id,
  business_id,
  offer,
  variant_id
) {
  return function(dispatch, getState) {
    let productsModified;
    dispatch({
      type: GET_PRODUCT_TO_CONFIGURE_REQUEST,
      hasErrors: true,
    });
    let businessId = business_id;

    if (!businessId) {
      const orderSettingReducer = getState().orderSettingReducer;

      if (orderSettingReducer.orderType === DELIVERY) {
        businessId =
          orderSettingReducer.interDeliveryDetails.deliveryBusiness.id;
      } else if (orderSettingReducer.orderType === DROPOFF) {
        businessId = orderSettingReducer.interDropOffDetails.id;
      } else {
        businessId = orderSettingReducer.interPickUpDetails.id;
      }
    }
    const comboCustomizerIsVisible = getState().comboReducer
      .comboCustomizerIsVisible;
    const selectedProductMenu = getState().menuReducer.products.find(
      (product) => product.product_id === product_id
    );
    const selectedProductUpsell = getState().upsellReducer.upsellProducts.find(
      (product) => product.product_id === product_id
    );
    const selectedProduct = selectedProductMenu || selectedProductUpsell;
    return getProduct(product_id, businessId, variant_id, selectedProduct).then(
      (response) => {
        let responseData = JSON.parse(JSON.stringify(response.data.data));
        if (comboCustomizerIsVisible) {
          responseData = transformComboItemForProductCustomizer(
            getState(),
            response.data.data
          );
        }
        if (offer && offer.web_conditions) {
          let pricesModified;
          if (offer.web_conditions?.discounted_variants.length > 0) {
            pricesModified = responseData.prices.filter((variant) =>
              offer.web_conditions.discounted_variants.includes(
                variant.variant_id
              )
            );
          }
          if (!pricesModified?.length) productsModified = responseData;
          else productsModified = { ...responseData, prices: pricesModified };
        } else {
          productsModified = responseData;
        }
        dispatch({
          type: GET_PRODUCT_TO_CONFIGURE_SUCCESS,
          response: { data: responseData },
          flatProduct: {
            ...useDefaultItems(flattenProduct(productsModified)),
            productLocationId: businessId,
          },
          selectedProduct: response.data.data,
          productCustomizerIsVisible: !comboCustomizerIsVisible,
        });
      },
      (error) => {
        dispatch({ type: GET_PRODUCT_TO_CONFIGURE_FAILURE, error });
      }
    );
  };
}

export function editPreviousProductConfiguration(
  productToEdit,
  isFlattened,
  isFavourite,
  isForEditing
) {
  return function(dispatch, getState) {
    const {
      interOrderType,
      interDeliveryDetails,
      interPickUpDetails,
      interDropOffDetails,
    } = getState().orderSettingReducer;

    dispatch({ type: EDIT_PREVIOUS_PRODUCT_CONFIGURATION_REQUEST });
    let flatProduct = productToEdit;
    if (!isFlattened) {
      flatProduct = flattenProduct({
        ...productToEdit,
        options: productToEdit.options || [],
      });
    }
    flatProduct = removeDefaultItems(flatProduct);
    productToEdit = {
      singlePrice: flatProduct.price,
      totalPrice: flatProduct.price * flatProduct.quantity,
      isEditing: isForEditing,
      isFromPreviousOrder: !isFavourite || false,
      isFromFavourites: isFavourite || false,
      requestGetProductToConfigure: false,
      selectedVariantId: flatProduct.variant_id,
      favouriteId: null,
      flatProduct: flatProduct,
    };

    const location =
      interOrderType === PICKUP && interPickUpDetails
        ? interPickUpDetails
        : interOrderType === DELIVERY &&
          interDeliveryDetails &&
          interDeliveryDetails.deliveryBusiness
        ? interDeliveryDetails.deliveryBusiness
        : interOrderType === DROPOFF && interDropOffDetails
        ? interDropOffDetails
        : null;

    const businessId = location ? location.id : null;

    if (businessId)
      combineProductOptionsAndItems(productToEdit, businessId, {
        has_valid_configuration: true,
      }).then((response) => {
        dispatch({
          type: EDIT_PREVIOUS_PRODUCT_CONFIGURATION_SUCCESS,
          productToEdit: response,
        });
      });
  };
}

export function changeVariant({
  selectedProduct,
  variantId,
  businessId,
  offer,
}) {
  return function(dispatch, getState) {
    const productId = selectedProduct.product_id;
    dispatch({
      type: CHANGE_VARIANT_REQUEST,
      selectedVariantId: variantId,
    });
    const { has_valid_configuration } = getState().menuReducer.products.find(
      (product) => product.product_id === productId
    );
    api
      .get(
        `/products/${productId}?business_id=${businessId}&include=options&variant_id=${variantId}&default_customization=${has_valid_configuration}`
      )
      .then(
        (response) => {
          const selectedProductModified = {
            ...response.data.data,
            prices: selectedProduct.prices,
          };
          dispatch({
            type: CHANGE_VARIANT_SUCCESS,
            response: selectedProductModified,
            flatProduct: perserveOnVariantChange(
              selectedProduct,
              flattenProduct(selectedProductModified)
            ),
          });
        },
        (error) => {
          dispatch({ type: CHANGE_VARIANT_FAILURE, error });
        }
      );
  };
}

export function combineProductOptionsAndItems(
  productToEdit,
  businessId,
  product
) {
  // will need to debug how this function is being used and add has_default_customization
  return getProduct(
    productToEdit.flatProduct.product_id,
    businessId,
    productToEdit.flatProduct.variant_id,
    product
  ).then((response) => {
    const flatProduct = flattenProduct(response.data.data);
    let itemsById = {};
    let subItemsById = {};
    Object.keys(flatProduct.itemsById).forEach((itemId) => {
      const isAvailable = flatProduct?.itemsById[itemId]?.is_available;
      itemsById[itemId] = {
        ...flatProduct.itemsById[itemId],
        quantity:
          isAvailable && productToEdit.flatProduct.itemsById[itemId]?.quantity
            ? productToEdit.flatProduct.itemsById[itemId]?.quantity
            : 0,
      };
    });
    Object.keys(flatProduct.subItemsById).forEach((itemId) => {
      const isAvailable = flatProduct.subItemsById[itemId].is_available;
      subItemsById[itemId] = {
        ...flatProduct.subItemsById[itemId],
        quantity:
          isAvailable &&
          productToEdit.flatProduct?.subItemsById[itemId]?.quantity
            ? productToEdit.flatProduct.subItemsById[itemId].quantity
            : 0,
      };
    });

    return {
      ...productToEdit,
      flatProduct: {
        ...productToEdit.flatProduct,
        options: flatProduct.options,
        optionsById: flatProduct.optionsById,
        subOptionsById: flatProduct.subOptionsById,
        itemsById,
        subItemsById,
      },
      selectedProduct: response.data.data,
    };
  });
}

export function incrementProductQuantity() {
  return {
    type: INCREMENT_PRODUCT_QUANTITY,
  };
}

export function decrementProductQuantity() {
  return {
    type: DECREMENT_PRODUCT_QUANTITY,
  };
}

export function incrementItem(item) {
  return {
    type: INCREMENT_ITEM,
    item,
  };
}

export function decrementItem(item) {
  return {
    type: DECREMENT_ITEM,
    item,
  };
}

export function removeItem(item) {
  return {
    type: REMOVE_ITEM,
    item,
  };
}

export function removeSubItem(subItem) {
  return {
    type: REMOVE_SUB_ITEM,
    subItem,
  };
}

export function incrementSubItem(subItem) {
  return {
    type: INCREMENT_SUB_ITEM,
    subItem,
  };
}

export function decrementSubItem(subItem, quantity) {
  return {
    type: DECREMENT_SUB_ITEM,
    subItem,
    quantity,
  };
}
export function addOrderInstruction(instruction) {
  return {
    type: ADD_ORDER_INSTRUCTION,
    instruction,
  };
}
export function setDrawerModalOpen(open) {
  return {
    type: SET_DRAWER_MODAL_OPEN,
    open,
  };
}

export function updatePrice(flatProduct) {
  const price = calculatePrice(flatProduct);
  return {
    type: UPDATE_PRICE,
    singlePrice: price.singlePrice,
    totalPrice: price.totalPrice,
  };
}

export function editProductConfiguration(productToEdit) {
  return function(dispatch, getState) {
    const comboCustomizerIsVisible = getState().comboReducer
      .comboCustomizerIsVisible;
    if (productToEdit.isFromPreviousOrder) {
      const businessId = getState().orderSettingReducer.interPickUpDetails.id;
      if (businessId)
        combineProductOptionsAndItems(productToEdit, businessId, {
          has_valid_configuration: true,
        }).then((response) => {
          dispatch({
            type: EDIT_PRODUCT_CONFIGURATION,
            productToEdit: response,
            isEditingFromOffers: true,
            productCustomizerIsVisible: !comboCustomizerIsVisible,
            selectedProduct: response?.selectedProduct,
          });
        });
    } else {
      dispatch({
        type: EDIT_PRODUCT_CONFIGURATION,
        productToEdit,
        isEditing: productToEdit.isEditing,
        productCustomizerIsVisible: !comboCustomizerIsVisible,
      });
    }
  };
}

export function cancelEditProductConfiguration() {
  return {
    type: CANCEL_EDIT_PRODUCT_CONFIGURATION,
  };
}

export function clearProductToConfigure() {
  return {
    type: CLEAR_PRODUCT_TO_CONFIGURE,
  };
}

export function validateProduct(validatedProduct) {
  return function(dispatch) {
    dispatch({
      type: VALIDATE_PRODUCT,
      validatedProduct,
    });
  };
}

export function validateOption(option, flatProduct) {
  return {
    type: VALIDATE_OPTION,
    validatedOption: updateOptionError(option, flatProduct),
  };
}
